// i18n 共享模块导出
// 注意：实际的 i18n 初始化在 web 和 mobile 端分别进行

export * from './config';

// 导出翻译资源（供 Mobile 端静态导入使用）
import zhCN_common from './locales/zh-CN/common.json';
import zhCN_settings from './locales/zh-CN/settings.json';
import zhCN_trade from './locales/zh-CN/trade.json';
import zhCN_auth from './locales/zh-CN/auth.json';
import zhCN_dashboard from './locales/zh-CN/dashboard.json';
import zhCN_emotion from './locales/zh-CN/emotion.json';
import zhCN_checklist from './locales/zh-CN/checklist.json';
import zhCN_profile from './locales/zh-CN/profile.json';
import zhCN_support from './locales/zh-CN/support.json';
import zhCN_reports from './locales/zh-CN/reports.json';
import zhCN_nav from './locales/zh-CN/nav.json';
import zhCN_about from './locales/zh-CN/about.json';
import zhCN_help from './locales/zh-CN/help.json';
import zhCN_strategy from './locales/zh-CN/strategy.json';

import enUS_common from './locales/en-US/common.json';
import enUS_settings from './locales/en-US/settings.json';
import enUS_trade from './locales/en-US/trade.json';
import enUS_auth from './locales/en-US/auth.json';
import enUS_dashboard from './locales/en-US/dashboard.json';
import enUS_emotion from './locales/en-US/emotion.json';
import enUS_checklist from './locales/en-US/checklist.json';
import enUS_profile from './locales/en-US/profile.json';
import enUS_support from './locales/en-US/support.json';
import enUS_reports from './locales/en-US/reports.json';
import enUS_nav from './locales/en-US/nav.json';
import enUS_about from './locales/en-US/about.json';
import enUS_help from './locales/en-US/help.json';
import enUS_strategy from './locales/en-US/strategy.json';

import zhTW_common from './locales/zh-TW/common.json';
import zhTW_settings from './locales/zh-TW/settings.json';
import zhTW_trade from './locales/zh-TW/trade.json';
import zhTW_auth from './locales/zh-TW/auth.json';
import zhTW_dashboard from './locales/zh-TW/dashboard.json';
import zhTW_emotion from './locales/zh-TW/emotion.json';
import zhTW_checklist from './locales/zh-TW/checklist.json';
import zhTW_profile from './locales/zh-TW/profile.json';
import zhTW_support from './locales/zh-TW/support.json';
import zhTW_reports from './locales/zh-TW/reports.json';
import zhTW_nav from './locales/zh-TW/nav.json';
import zhTW_about from './locales/zh-TW/about.json';
import zhTW_help from './locales/zh-TW/help.json';
import zhTW_strategy from './locales/zh-TW/strategy.json';

export const resources = {
  'zh-CN': {
    common: zhCN_common,
    settings: zhCN_settings,
    trade: zhCN_trade,
    auth: zhCN_auth,
    dashboard: zhCN_dashboard,
    emotion: zhCN_emotion,
    checklist: zhCN_checklist,
    profile: zhCN_profile,
    support: zhCN_support,
    reports: zhCN_reports,
    nav: zhCN_nav,
    about: zhCN_about,
    help: zhCN_help,
    strategy: zhCN_strategy,
  },
  'en-US': {
    common: enUS_common,
    settings: enUS_settings,
    trade: enUS_trade,
    auth: enUS_auth,
    dashboard: enUS_dashboard,
    emotion: enUS_emotion,
    checklist: enUS_checklist,
    profile: enUS_profile,
    support: enUS_support,
    reports: enUS_reports,
    nav: enUS_nav,
    about: enUS_about,
    help: enUS_help,
    strategy: enUS_strategy,
  },
  'zh-TW': {
    common: zhTW_common,
    settings: zhTW_settings,
    trade: zhTW_trade,
    auth: zhTW_auth,
    dashboard: zhTW_dashboard,
    emotion: zhTW_emotion,
    checklist: zhTW_checklist,
    profile: zhTW_profile,
    support: zhTW_support,
    reports: zhTW_reports,
    nav: zhTW_nav,
    about: zhTW_about,
    help: zhTW_help,
    strategy: zhTW_strategy,
  },
};
